import React, { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import {
    amountInDecimal,
    BigText,
    CancelNextButton,
    FinishPageType,
    FlowPage,
    FlowPageProps,
    Highlight,
    NormalText,
    SmallestText,
    SmallText,
} from "../cancelFlow";
import {
    useCurrentStripePlan,
    useStripeSubscription,
    useStripeUpgradePlan,
} from "../../../../../components/hooks";
import { getLocale } from "../../../../../utils/localeUtils";
import { formatForCurrency } from "../../../../../utils/CurrencySymbol";
import { IonButton, IonLoading, IonText } from "@ionic/react";
import {
    asPlanType,
    planDisplayName,
} from "../../../../../services/StripeService";
import * as stripeService from "../../../../../services/StripeService";
import { trackEvent } from "../../../../../services/analytics/analyticsService";
import { ProductBadge } from "../../../../../components/ProductBadge";

export const SwitchToMonthlyToManageCostPage: FC<FlowPageProps> = ({
    next,
    finish,
    reason,
}) => {
    const { t } = useTranslation();
    const sub = useStripeSubscription();
    const currentPlan = useCurrentStripePlan();
    const upgradePlan = useStripeUpgradePlan(
        "month",
        sub?.planFeatures || "",
        true
    );
    const currency = currentPlan?.currency || "GBP";
    if (!sub) {
        return <></>;
    }
    const planType = asPlanType(sub.planFeatures);

    const upgradePlanAmount = amountInDecimal(upgradePlan?.amount, currency);
    const locale = getLocale();
    const onClick = async () => {
        try {
            if (sub) {
                const planType = asPlanType(sub.planFeatures);
                await stripeService.updatePlan("month", planType);
                trackEvent("CancellationOutcome", {
                    reason: reason,
                    outcome: "switched-to-monthly",
                });
            }
        } catch (e) {
            console.error(e);
        }
        return FinishPageType.OfferSwitch;
    };
    return (
        <FlowPage className={"switch-to-monthly"}>
            <ProductBadge type={planType} height={"30px"} />
            <div className={"content"}>
                <NormalText>
                    {t("cancellation.screens.manageCosts.title")}
                </NormalText>
                <BigText>
                    <Trans
                        i18nKey={"cancellation.screens.manageCosts.text"}
                        values={{
                            price: formatForCurrency(
                                upgradePlanAmount,
                                currency,
                                locale
                            ),
                        }}
                        components={{ b: <Highlight /> }}
                    />
                </BigText>
            </div>
            <SmallText>
                {t("cancellation.screens.manageCosts.footer", {
                    newPlan: planDisplayName(upgradePlan),
                })}
            </SmallText>
            <CancelNextButton next={next}>
                {t("cancellation.screens.manageCosts.noButton")}
            </CancelNextButton>
            <IonButton onClick={() => finish && finish(onClick)}>
                {t("general.yes")}
            </IonButton>
        </FlowPage>
    );
};
